var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('header',[_vm._v("Contact Us")]),_c('p',[_vm._v(" contact "),_c('span',{staticStyle:{"color":"blue"}},[_vm._v("report@habagogo.com")])])])
}]

export { render, staticRenderFns }